import { InstallCustomerRequest } from 'src/modules/support/models/installCustomerRequest';
import AxiosInstance from './axios/interceptor';

const controller = 'System';

export interface InstallStep {
  name: string;
  success: boolean;
  message: string;
}

export interface InstallCustomerResult {
  success: boolean;
  steps: InstallStep[];
  custName: string;
}

export const createCustomer = (data: InstallCustomerRequest) => {
  const endpoint = `${controller}/InstallCustomer`;
  return AxiosInstance.put<InstallCustomerResult>(endpoint, data);
};

export const sendInvitation = (data: InstallCustomerRequest) => {
  const endpoint = `${controller}/SendInvitation`;
  return AxiosInstance.put(endpoint, data);
};
